import styled, { DefaultTheme, css } from 'styled-components';
import { InfoMessageTypes } from '.';

type WrapperProps = Pick<InfoMessageTypes, 'variant'>;

const WrapperModifiers = {
  warning: (theme: DefaultTheme) => css`
    background-color: ${theme.colors.statusWarning10};

    > p {
      color: ${theme.colors.statusWarning50};
    }
  `,
};

export const Wrapper = styled.div<WrapperProps>`
  ${({ theme, variant }) => css`
    width: 100%;
    border-radius: 4px;
    padding: 12px;
    display: flex;
    align-items: center;

    > p {
      font-weight: 500;
      font-size: 1.2rem;
      line-height: 1.9rem;
      margin: 0;
    }

    @media (max-width: 768px) {
      > p {
        line-height: 1.6;
      }
    }

    ${variant && WrapperModifiers[variant](theme)}
  `}
`;

export const Icon = styled.div`
  width: 16px;
  height: 16px;
  margin-right: 12px;
`;
